import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var HTTPRequestHeaders =
/*#__PURE__*/
function () {
  function HTTPRequestHeaders(init) {
    _classCallCheck(this, HTTPRequestHeaders);

    /**
     * The actual headers.
     */
    this._headers = {};
    /**
     * The number of headers present.
     */

    this._count = 0;

    this._setAll(init);
  }

  _createClass(HTTPRequestHeaders, [{
    key: "_setAll",
    value: function _setAll(init) {
      var count = 0;

      for (var key in init) {
        if (!init.hasOwnProperty(key) || !init[key]) {
          continue;
        }

        this._headers[key.toLowerCase()] = init[key];
        count++;
      }

      this._count = count;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._headers[name.toLowerCase()] || null;
    }
  }, {
    key: "has",
    value: function has(name) {
      return !!this._headers[name.toLowerCase()];
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this._headers[name.toLowerCase()] = value;
      this._count++;
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      var _name = name.toLowerCase();

      if (this._headers[_name]) {
        this._count--;
      }

      delete this._headers[name.toLowerCase()];
    }
  }, {
    key: "count",
    value: function count() {
      return this._count;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.assign({}, this._headers);
    }
  }]);

  return HTTPRequestHeaders;
}();